import { Component } from "react";

import {
	ALL_MODELS,
	ARTICLES,
	CLASSIFICATION_MODELS,
	DATA_TYPES,
	MODEL_STATES,
	PAIR_PLOT_RADIALS,
	REGRESSSION_MODELS,
	TOTAL_PROGRESS_WEIGHTS,
} from "./constants";
import { makeCleanDataFilter } from "./dashboard/DataCleaning/filters";
import { clusterStats } from "./dashboard/PersonaGroupings/groupCalcs";
import { batchDataType } from "./helpers/processBatchData";
import Column from "./MachineLearning/Column";
import { getSaveState, newObj, saveStateType } from "./saveState";

import {
	getEmptyCustomTopic,
	MAX_TOPICS,
} from "./dashboard/PersonaGroupings/CustomTopicTable";
import { examples, examples2 } from "./homePage/UseCases";

export type contactFormType = {
	first: string;
	last: string;
	email: string;
	message: string;
};

export type addChartProps = {
	title: string;
	chart_type: string;
	var1: string;
	var2: string;
	value: string;
	agg_type: string;
	index: number;
};

export type chartAggType = {
	rowLabels: string[];
	colLabels: string[];
	arr: string[][];
	counts: number[][];
};

export type addedChartsType = {
	chartProps: addChartProps;
	chartAggData: chartAggType;
};

export type personaType = {
	predictorValues: Object;
	name: string;
	avatar: string;
	predicted: string;
};

export type batchFilterType = {
	column: string;
	operation: string;
	value: string;
	isValid: boolean;
};

export type cleanDataFilterType = {
	column: string;
	operation: string;
	value: string;
	replace_with: string;
	drop_row: boolean;
	index: number;
};

export type modelPredictionsType = { yTest: number[]; yHat: number[] };

export type catModelPredictionsType = {
	actualCount: number;
	predictedCount: number;
	correct: number;
	accuracy: number;
};

export interface catModelPredsObj {
	[key: string]: catModelPredictionsType;
}

export interface datasetData {
	[key: string]: string[];
}

export type stateTypeF = {
	isBusy: boolean;
	setIsBusy: (isBusy: boolean) => void;
	isTraining: boolean;
	setIsTraining: (isBusy: boolean) => void;
	isProcessingData: boolean;
	setIsProcessingData: (isProcessingData: boolean) => void;
	currentModels: string[];
	setCurrentModels: (colType: string) => void;
	modelProgress: Object;
	progressBars: Map<string, number>;

	setModelDescription: (title: string) => void;
	setModelProgress: (modelProgress: Map<string, number>) => void;
	setChosenModels: (chosenModels: string[]) => void;
	chosenModels: string[];
	trainingCanceled: boolean;
	setTrainingCanceled: (trainingCanceled: boolean) => void;
	getTrainingCanceled: () => boolean;
	setTotalTrainProgress: (
		chosenModels: string[],
		modelProgress: Object,
		modelStates: Object
	) => void;
	totalTrainProgress: number;
	resetTotalTrainProgress: () => void;
	setModelState: (
		modelName: string,
		modelState: number,
		modelStates: Object
	) => void;
	resetModelStates: (modelStates: Object, excludeSelected?: boolean) => void;
	resetSavedModels: () => void;
	resetErrorStates: (columns: Column[]) => void;
	setSelected: (selected: string[]) => void;
	inputsPage: number;
	setInputPage: (nextPage: number) => void;
	resetPredictorValues: () => void;
	personaErrorStates: Map<string, boolean>;
	setPersonaErrorStates: (personaErrorStates: Map<string, boolean>) => void;
	selectedPersonaInput: string;
	setSelectedPersonaInput: (value: string) => void;
	colNames: string[];
	setColNames: (colNames: string[]) => void;
	setTempDataStr: (dataStr: string) => void;
	tempDataStr: string;
	getTempDataStr: () => string;
	isDialogOpen: boolean;
	setIsDialogOpen: (isOpen: boolean) => void;
	getIsDialogOpen: () => boolean;
	dialogText: string;
	setDialogText: (dialogText: string) => void;
	isResetDialogOpen: boolean;
	setIsResetDialogOpen: (isOpen: boolean) => void;
	isResetDialogOpen2: boolean;
	setIsResetDialogOpen2: (isOpen: boolean) => void;
	clientID: string;
	setClientID: (clientID: string) => void;
	getClientID: () => string;
	isLoggedIn: boolean;
	avatarURL: string;
	clientName: string;
	setIsLoggedIn: (val: boolean) => void;
	getIsLoggedIn: () => boolean;
	setAvatarURL: (url: string) => void;
	setClientName: (name: string) => void;
	getClientName: () => string;
	isPurchaseOpen: boolean;
	setIsPurchaseOpen: (isPurchaseOpen: boolean) => void;
	isLoginOpen: boolean;
	setIsLoginOpen: (isLoginOpen: boolean) => void;
	subPrice: { monthly: string; yearly: string; discount: string };
	setSubPrice: (subPrice: { monthly: string; yearly: string }) => void;
	dashboardNames: string[];
	setDashboardNames: (dashboardNames: string[]) => void;
	isNewDashWarnOpen: boolean;
	setIsNewDashWarnOpen: (isNewDashOpen: boolean) => void;
	isChangeDashWarnOpen: boolean;
	setIsChangeDashWarnOpen: (isNewDashOpen: boolean) => void;
	isSaved: boolean;
	setIsSaved: (isSaved: boolean) => void;
	dropzoneOpen: any;
	setDropzoneOpen: (openD: any, saveTF: boolean) => void;
	isConfirmDeleteOpen: boolean;
	setIsConfirmDeleteOpen: (confirmDeleteOpen: boolean) => void;
	selectedToDelete: string;
	setSelectedToDelete: (selectedToDelete: string) => void;
	pubKey: string;
	setPubKey: (pubKey: string) => void;
	ISP: boolean;
	setISP: (ISP: boolean) => void;
	getISP: () => boolean;
	newDashNameConflict: boolean;
	setNewDashNameConflict: (newDashNameConflict: boolean) => void;
	newDashInput: string;
	setNewDashInput: (newDashInput: string) => void;
	requirementsOpen: boolean;
	setRequirementsOpen: (requirementsOpen: boolean) => void;
	isContactUsOpen: boolean;
	setIsContactUsOpen: (isContactUsOpen: boolean) => void;
	contactUsSuccess: boolean;
	setContactUsSuccess: (contactUsSuccess: boolean) => void;
	newDashDisabled: boolean;
	setNewDashDisabled: (newDashDisabled: boolean) => void;
	isUnsubOpen: boolean;
	setIsUnsubOpen: (isUnsubOpen: boolean) => void;
	isUnsubConfirmOpen: boolean;
	setIsUnsubConfirmOpen: (isUnsubConfirmOpen: boolean) => void;
	subStatus: string;
	setSubStatus: (subStaus: string) => void;
	getSubStatus: () => string;
	unsubDate: string;
	setUnsubDate: (unsubDate: string) => void;
	isDeleteOpen: boolean;
	setIsDeleteOpen: (isDeleteOpen: boolean) => void;

	isDeleteConfirmOpen: boolean;
	setIsDeleteConfirmOpen: (isDeleteConfirmOpen: boolean) => void;

	numericHistSelected: string;
	setNumericHistSelected: (numericHistSelected: string) => void;

	isScatterDialogOpen: boolean;
	setIsScatterDialogOpen: (isScatterDialogOpen: boolean) => void;
	scatterXY: { x: number; y: number };
	setScatterXY: (scatterXY: { x: number; y: number }) => void;

	capOutliersHist: boolean;
	setCapOutliersHist: (capOutliersHist: boolean) => void;

	pcaEncodedData: number[][];
	setPcaEncodedData: (pcaEncodedData: number[][]) => void;

	getPcaEncodedData: () => number[][];

	groupStates: clusterStats[][][];
	setGroupStates: (groupStates: clusterStats[][][]) => void;

	getCurrentModels: (colType: string) => string[];

	groupAccordiansOpen: boolean[];
	setGroupAccordiansOpen: (groupAccordiansOpen: boolean[]) => void;

	jiggleFactor: number;
	setJiggleFactor: (jiggleFactor: number) => void;

	plotRadialsSelected: string;
	setPlotRadialsSelected: (plotRadialsSelected: string) => void;

	dragVarsState: {
		draggable: string[];
		rows: string[];
		cols: string[];
		values: string[];
	};

	setDragVarsState: (dragVarsState: {
		draggable: string[];
		rows: string[];
		cols: string[];
		values: string[];
	}) => void;

	isAddChartOpen: boolean;
	setIsAddChartOpen: (isAddChartOpen: boolean) => void;

	addChartInputs: addChartProps;
	setAddChartInputs: (addChartInputs: addChartProps) => void;
	resetAddChartInputs: () => void;

	chartAggData: chartAggType;
	setChartAggData: (chartAggData: chartAggType) => void;

	addedCharts: addedChartsType[];
	setAddedCharts: (addedCharts: addedChartsType[]) => void;

	isAddPopupEditMode: boolean;
	setIsAddPopupEditMode: (isAddPopupEditMode: boolean) => void;

	resetModelProgress: () => void;

	nPersonaPages: number;
	setNPersonaPages: (nPersonaPages: number) => void;

	currentPersonaPage: number;
	setCurrentPersonaPage: (currentPersonaPage: number) => void;

	personaPredicted: string;
	setPersonaPredicted: (personaPredicted: string) => void;

	isPersonaPopupOpen: boolean;
	setIsPersonaPopupOpen: (isPersonaPopupOpen: boolean) => void;

	personaName: string;
	setPersonaName: (personaName: string) => void;

	isDeletPersonaOpen: boolean;
	setIsDeletePersonaOpen: (isDeletPersonaOpen: boolean) => void;

	personaAvatarSelected: number;
	setPersonaAvatarSelected: (personaAvatarSelected: number) => void;

	editingPersona: number;
	setEditingPersona: (editingPersona: number) => void;

	cleanData: batchDataType;
	setCleanData: (cleanData: batchDataType) => void;

	isAnalyzing: boolean;
	setIsAnalyzing: (isAnalyzing: boolean) => void;

	isLoadingPopupOpen: boolean;
	setIsLoadingPopupOpen: (isLoadingPopupOpen: boolean) => void;

	batchTableColSort: string[];
	setBatchTableColSort: (batchTableColSort: string[]) => void;

	batchTablePage: number;
	setBatchTablePage: (batchTablePage: number) => void;

	batchFilters: batchFilterType[];
	setBatchFilters: (batchFilters: batchFilterType[]) => void;

	batchFilteredData: any[][];
	setBatchFilteredData: (batchFilteredData: any[][]) => void;

	cleanTableColSort: string[];
	setCleanTableColSort: (batchTableColSort: string[]) => void;

	cleanTablePage: number;
	setCleanTablePage: (batchTablePage: number) => void;

	cleanFilters: batchFilterType[];
	setCleanFilters: (batchFilters: batchFilterType[]) => void;

	cleanFilteredData: any[][];
	setCleanFilteredData: (batchFilteredData: any[][]) => void;

	scatterCleanVarsSelected: string[];
	setScatterCleanVarsSelected: (scatterCleanVarsSelected: string[]) => void;

	currentDataFilter: cleanDataFilterType;
	setCurrentDataFilter: (currentDataFilter: cleanDataFilterType) => void;

	dropRowsFilterSelected: boolean;
	setDropRowsFilterSelected: (dropRowsFilterSelected: boolean) => void;

	filterSummary: { rowsModified: number; rowsDropped: number };
	setFilterSummary: (filterSummary: {
		rowsModified: number;
		rowsDropped: number;
	}) => void;

	autoFilters: cleanDataFilterType[];
	setAutoFilters: (autoFilters: cleanDataFilterType[]) => void;

	isNewDashPopUpOpen: boolean;
	setIsNewDashPopUpOpen: (isNewDashPopUpOpen: boolean) => void;

	tempDashName: string;
	setTempDashName: (tempDashName: string) => void;

	setNewDashName: () => void;

	dashToDelete: string;
	setDashToDelete: (dashToDelete: string) => void;

	isDeleteDashOpen: boolean;
	setIsDeleteDashOpen: (isDeleteDashOpen: boolean) => void;

	isSaveErrorOpen: boolean;
	setIsSaveErrorOpen: (isSaveErrorOpen: boolean) => void;

	saveErrorMessage: string;
	setSaveErrorMessage: (saveErrorMessage: string) => void;

	isResetDashOpen: boolean;
	setIsResetDashOpen: (isResetDashOpen: boolean) => void;

	isRejectedDropOpen: boolean;
	setIsRejectedDropOpen: (isRejectedDropOpen: boolean) => void;

	rejectedReason: string;
	setRejectedReason: (rejectedReason: string) => void;

	isSavingDashOpen: boolean;
	setIsSavingDashOpen: (isSavingDashOpen: boolean) => void;

	exHoverState: Map<string, number>;
	setExHoverState: (exHoverState: Map<string, number>) => void;
	getExHoverState: () => Map<string, number>;

	isSuccessContactOpen: boolean;
	isFailedContactOpen: boolean;
	setIsSuccessContactOpen: (isSuccessContactOpen: boolean) => void;
	setIsFailedContactOpen: (isSuccessContactOpen: boolean) => void;

	contactStatusMessage: string;
	setContactStatusMessage: (failedMessage: string) => void;

	isContactSubmitDisabled: boolean;
	setIsContactSubmitDisabled: (isSuccessContactOpen: boolean) => void;

	setContactEndpoint: (contactEndpoint: string) => void;

	articleApplicationSelected: string;
	setArticleApplicationSelected: (articleApplicationSelected: string) => void;

	nClusters: number;
	setNeClusters: (nClusters: number) => void;

	isCloudPopupOpen: boolean;
	setIsCloudPopupOpen: (isCloudPopupOpen: boolean) => void;

	tagClicked: string;
	setTagClicked: (tagClicked: string) => void;

	cloudPopupPageSelected: number;
	setCloudPopupPageSelected: (cloudPopupPageSelected: number) => void;

	enteredPhrases: string[];
	setEnteredPhrases: (enteredPhrases: string, ndx: number) => void;
	enteredTopicNames: string[];
	setEnteredTopicNames: (enteredTopicNames: string[]) => void;

	checkedTopics: boolean[];
	setCheckedTopics: (checkedTopics: boolean, index: number) => void;

	setAllCheckedTopics: (checkedTopics: boolean[]) => void;
	setAllEnteredPhrases: (enteredPhrases: string[]) => void;

	isTopicsProcessing: boolean;
	setIsTopicsProcessing: (isTopicsProcessing: boolean) => void;
	shouldUpdatePhrases: boolean;
	setShouldUpdatePhrases: (shouldUpdatePhrases: boolean) => void;

	reCaclSentTable: boolean;
	setReCalcSentTable: (reCaclSentTable: boolean) => void;

	sentTableData: any[][];
	setSentTableData: (sentTableData: any[][]) => void;

	isPosCloudOpen: boolean;
	setIsPosCloudOpen: (isPosCloudOpen: boolean) => void;
	isNegCloudOpen: boolean;
	setIsNegCloudOpen: (isNegCloudOpen: boolean) => void;

	errorCaught: boolean;
	setErrorCaught: (errorCaught: boolean) => void;

	errorPopupOpen: boolean;
	setErrorPopupOpen: (errorPopupOpen: boolean) => void;

	// Save States
	saveState: typeof saveStateType;
	setSaveState: (
		saveState_: typeof saveStateType,
		isModified?: boolean
	) => void;
	setFileName: (fileName: string, saveState_: typeof saveStateType) => void;

	saveStateModified: boolean;
	setSaveStateModified: (saveStateModified: boolean) => void;
	isFirstLoad: boolean;
	setIsFirstLoad: (tf: boolean) => void;
};
export type stateType = {
	state: stateTypeF;
};

export function createState(inParentComponent: Component): stateTypeF {
	return {
		isFirstLoad: false,
		setIsFirstLoad: function (isBusy: boolean) {
			this.setState({ isFirstLoad: isBusy });
		}.bind(inParentComponent),

		isBusy: false,
		setIsBusy: function (isBusy: boolean) {
			this.setState({ isBusy: isBusy });
		}.bind(inParentComponent),
		isTraining: false,
		setIsTraining: function (isTraining: boolean) {
			this.setState({ isTraining: isTraining });
		}.bind(inParentComponent),
		isProcessingData: false,
		setIsProcessingData: function (isProcessingData: boolean) {
			this.setState({ isProcessingData: isProcessingData });
		}.bind(inParentComponent),
		// Dropzone Box

		setTempDataStr: function (dataStr: string) {
			this.setState({ tempDataStr: dataStr });
		}.bind(inParentComponent),
		tempDataStr: "",
		getTempDataStr: function () {
			return this.state.tempDataStr;
		}.bind(inParentComponent),
		setColNames: function (colNames: string[]) {
			this.setState({ colNames: colNames });
		}.bind(inParentComponent),

		// Models
		trainingCanceled: false,
		setTrainingCanceled: function (trainingCanceled: boolean) {
			this.setState({ trainingCanceled: trainingCanceled });
		}.bind(inParentComponent),
		getTrainingCanceled: function () {
			return this.state.trainingCanceled;
		}.bind(inParentComponent),
		setCurrentModels: function (colType: string) {
			let models: string[];
			if (colType === DATA_TYPES.number) {
				models = Object.values(REGRESSSION_MODELS);
			} else if (colType === DATA_TYPES.categorical) {
				models = Object.values(CLASSIFICATION_MODELS);
			} else {
				console.log("NoModels");
			}
			this.setState({ currentModels: models });
		}.bind(inParentComponent),
		currentModels: undefined,
		modelProgress: newObj(Object.values(ALL_MODELS), 0),
		resetModelProgress: function () {
			const modelProgress = {};
			for (let val of Object.values(ALL_MODELS)) {
				modelProgress[val] = 0;
			}
			this.state.saveState.modelTraining.modelProgress = modelProgress;
			this.setState({ saveState: this.state.saveState });
		}.bind(inParentComponent),
		progressBars: new Map(
			["dataPrepare", "totalTrain", "prediction"].map((value) => [
				value,
				0,
			])
		),

		setModelDescription: function (title: string) {
			this.setState({ modelTitle: title });
		}.bind(inParentComponent),
		setModelProgress: function (modelProgress: Map<string, number>) {
			this.setState({ modelProgress: modelProgress });
		}.bind(inParentComponent),
		chosenModels: [REGRESSSION_MODELS.svm],
		setChosenModels: function (chosenModels: string[]) {
			this.setState({ chosenModels: chosenModels });
		}.bind(inParentComponent),
		setTotalTrainProgress: function (
			currentModels: string[],
			modelProgress: Object,
			modelStates: Object
		) {
			let totalWeight = 0;
			let trainProgress = 0;
			for (let chosen of currentModels) {
				if (
					modelStates[chosen] === MODEL_STATES.unselected ||
					modelStates[chosen] === MODEL_STATES.premOnly
				) {
					continue;
				}
				let weight = TOTAL_PROGRESS_WEIGHTS[chosen];
				trainProgress += weight * modelProgress[chosen];
				totalWeight += weight;
			}
			this.state.saveState.modelTraining.totalTrainProgress =
				trainProgress / totalWeight;

			this.setState({
				saveState: this.state.saveState,
			});
		}.bind(inParentComponent),
		resetTotalTrainProgress: function () {
			this.state.saveState.modelTraining.totalTrainProgress = 0;
			this.setState({
				saveState: this.state.saveState,
			});
		}.bind(inParentComponent),

		totalTrainProgress: 0,
		setModelState: function (
			modelName?: string,
			modelState?: number,
			modelStates?: Object
		) {
			if (modelName !== undefined) {
				modelStates[modelName] = modelState;
			}
			this.state.saveState.modelTraining.modelStates = modelStates;
			this.state.setSaveState(this.state.saveState);
			// this.setState({ modelStates: modelStates });
		}.bind(inParentComponent),
		resetModelStates: function (
			modelStates: Object,
			excludeSelected = true
		) {
			let modelNames = Object.values(ALL_MODELS);
			if (excludeSelected) {
				modelNames = modelNames.filter(
					(name) => modelStates[name] != MODEL_STATES.unselected
				);
			}

			modelNames.forEach((key) => {
				modelStates[key] =
					modelStates[key] === MODEL_STATES.premOnly
						? MODEL_STATES.premOnly
						: MODEL_STATES.ready;
			});
			this.setState({ modelStates: modelStates });
		}.bind(inParentComponent),
		resetSavedModels: function () {
			this.setState({ savedModels: [] });
		}.bind(inParentComponent),
		resetErrorStates: function (columns: Column[]) {
			const colNames = columns.map((val) => val.columnName);
			const personaErrorStates = new Map(
				colNames.map((name) => [name, false])
			);
			this.setState({ personaErrorStates: personaErrorStates });
		}.bind(inParentComponent),

		// Data Box
		colNames: [],

		setSelected: function (selected: string[]) {
			this.setState({ selectedRows: selected });
		}.bind(inParentComponent),

		//Prediction Box
		inputsPage: 0,
		setInputPage: function (nextPage: number) {
			this.setState({ inputsPage: nextPage });
		}.bind(inParentComponent),
		resetPredictorValues: function () {
			let empty: Map<string, string> = new Map();
			this.setState({ predictorValues: empty });
		}.bind(inParentComponent),
		personaErrorStates: new Map(),
		setPersonaErrorStates: function (
			personaErrorStates: Map<string, boolean>
		) {
			this.setState({ personaErrorStates: personaErrorStates });
		}.bind(inParentComponent),
		selectedPersonaInput: "",
		setSelectedPersonaInput: function (value: string) {
			this.setState({ selectedPersonaInput: value });
		}.bind(inParentComponent),
		isDialogOpen: false,
		setIsDialogOpen: function (isOpen: boolean) {
			this.setState({ isDialogOpen: isOpen });
		}.bind(inParentComponent),
		getIsDialogOpen: function () {
			return this.state.isDialogOpen;
		}.bind(inParentComponent),
		dialogText: "",
		setDialogText: function (dialogText: string) {
			this.setState({ dialogText: dialogText });
		}.bind(inParentComponent),
		isResetDialogOpen: false,
		setIsResetDialogOpen: function (isOpen: boolean) {
			this.setState({ isResetDialogOpen: isOpen });
		}.bind(inParentComponent),
		isResetDialogOpen2: false,
		setIsResetDialogOpen2: function (isOpen: boolean) {
			this.setState({ isResetDialogOpen2: isOpen });
		}.bind(inParentComponent),
		clientID: "Alex",
		setClientID: function (clientID: string) {
			this.setState({ clientID: clientID });
		}.bind(inParentComponent),
		getClientID: function () {
			return this.state.clientID;
		}.bind(inParentComponent),
		isLoggedIn: false,
		avatarURL: "",
		clientName: "",
		setIsLoggedIn: function (isLoggedIn: boolean) {
			this.setState({ isLoggedIn: isLoggedIn });
		}.bind(inParentComponent),
		getIsLoggedIn: function () {
			return this.state.isLoggedIn;
		}.bind(inParentComponent),
		setAvatarURL: function (avatarURL: string) {
			this.setState({ avatarURL: avatarURL });
		}.bind(inParentComponent),
		setClientName: function (clientName: string) {
			this.setState({ clientName: clientName });
		}.bind(inParentComponent),
		getClientName: function () {
			return this.state.clientName;
		}.bind(inParentComponent),
		isPurchaseOpen: false,
		setIsPurchaseOpen: function (isPurchaseOpen: boolean) {
			this.setState({ isPurchaseOpen: isPurchaseOpen });
		}.bind(inParentComponent),
		isLoginOpen: false,
		setIsLoginOpen: function (isLoginOpen: boolean) {
			this.setState({ isLoginOpen: isLoginOpen });
		}.bind(inParentComponent),
		subPrice: { monthly: "", yearly: "", discount: "" },
		setSubPrice: function (subPrice: { monthly: string; yearly: string }) {
			this.setState({ subPrice: subPrice });
		}.bind(inParentComponent),
		dashboardNames: [""],
		setDashboardNames: function (dashboardNames: string[]) {
			this.setState({ dashboardNames: dashboardNames });
		}.bind(inParentComponent),
		isSaved: true,
		setIsSaved: function (isSaved: boolean) {
			this.setState({ isSaved: isSaved });
		}.bind(inParentComponent),
		isNewDashWarnOpen: false,
		setIsNewDashWarnOpen: function (isNewDashWarnOpen: boolean) {
			this.setState({ isNewDashWarnOpen: isNewDashWarnOpen });
		}.bind(inParentComponent),
		dropzoneOpen: () => {},
		setDropzoneOpen: function (dropzoneOpen: any, saveTF: boolean) {
			if (saveTF) {
				this.setState({ dropzoneOpen: dropzoneOpen });
			}
		}.bind(inParentComponent),
		isChangeDashWarnOpen: false,
		setIsChangeDashWarnOpen: function (isChangeDashWarnOpen: boolean) {
			this.setState({ isChangeDashWarnOpen: isChangeDashWarnOpen });
		}.bind(inParentComponent),
		isConfirmDeleteOpen: false,
		setIsConfirmDeleteOpen: function (isConfirmDeleteOpen: boolean) {
			this.setState({ isConfirmDeleteOpen: isConfirmDeleteOpen });
		}.bind(inParentComponent),
		selectedToDelete: "",
		setSelectedToDelete: function (selectedToDelete: boolean) {
			this.setState({ selectedToDelete: selectedToDelete });
		}.bind(inParentComponent),
		pubKey: undefined,
		setPubKey: function (pubKey: string) {
			this.setState({ pubKey: pubKey });
		}.bind(inParentComponent),
		ISP: false,
		setISP: function (ISP: boolean) {
			this.setState({ ISP: ISP });
		}.bind(inParentComponent),
		getISP: function () {
			return true;
		}.bind(inParentComponent),
		newDashNameConflict: false,
		setNewDashNameConflict: function (newDashNameConflict: boolean) {
			this.setState({ newDashNameConflict: newDashNameConflict });
		}.bind(inParentComponent),
		newDashInput: "",
		setNewDashInput: function (newDashInput: string) {
			this.setState({ newDashInput: newDashInput });
		}.bind(inParentComponent),
		requirementsOpen: false,
		setRequirementsOpen: function (requirementsOpen: boolean) {
			this.setState({ requirementsOpen: requirementsOpen });
		}.bind(inParentComponent),
		isContactUsOpen: false,
		setIsContactUsOpen: function (isContactUsOpen: boolean) {
			this.setState({ isContactUsOpen: isContactUsOpen });
		}.bind(inParentComponent),
		contactUsSuccess: false,
		setContactUsSuccess: function (contactUsSuccess: boolean) {
			this.setState({ contactUsSuccess: contactUsSuccess });
		}.bind(inParentComponent),
		newDashDisabled: false,
		setNewDashDisabled: function (newDashDisabled: boolean) {
			this.setState({ newDashDisabled: newDashDisabled });
		}.bind(inParentComponent),
		isUnsubOpen: false,
		setIsUnsubOpen: function (isUnsubOpen: boolean) {
			this.setState({ isUnsubOpen: isUnsubOpen });
		}.bind(inParentComponent),
		isUnsubConfirmOpen: false,
		setIsUnsubConfirmOpen: function (isUnsubConfirmOpen: boolean) {
			this.setState({ isUnsubConfirmOpen: isUnsubConfirmOpen });
		}.bind(inParentComponent),
		subStatus: "Not Subscribed",
		setSubStatus: function (subStatus: string) {
			this.setState({ subStatus: subStatus });
		}.bind(inParentComponent),
		getSubStatus: function () {
			return this.state.subStatus;
		}.bind(inParentComponent),
		unsubDate: null,
		setUnsubDate: function (unsubDate: string) {
			this.setState({ unsubDate: unsubDate });
		}.bind(inParentComponent),

		isDeleteOpen: false,
		setIsDeleteOpen: function (isDeleteOpen: boolean) {
			this.setState({ isDeleteOpen: isDeleteOpen });
		}.bind(inParentComponent),
		isDeleteConfirmOpen: false,
		setIsDeleteConfirmOpen: function (isDeleteConfirmOpen: boolean) {
			this.setState({ isDeleteConfirmOpen: isDeleteConfirmOpen });
		}.bind(inParentComponent),
		numericHistSelected: "",
		setNumericHistSelected: function (numericHistSelected: string) {
			this.setState({ numericHistSelected: numericHistSelected });
		}.bind(inParentComponent),
		isScatterDialogOpen: false,
		setIsScatterDialogOpen: function (isScatterDialogOpen: boolean) {
			this.setState({ isScatterDialogOpen: isScatterDialogOpen });
		}.bind(inParentComponent),
		scatterXY: { x: 0, y: 0 },
		setScatterXY: function (scatterXY: { x: number; y: number }) {
			this.setState({ scatterXY: scatterXY });
		}.bind(inParentComponent),
		capOutliersHist: true,
		setCapOutliersHist: function (capOutliersHist: boolean) {
			this.setState({ capOutliersHist: capOutliersHist });
		}.bind(inParentComponent),
		pcaEncodedData: [
			[1, 2],
			[3, 40],
		],
		setPcaEncodedData: function (pcaEncodedData2: number[][]) {
			this.setState({ pcaEncodedData: pcaEncodedData2 });
		}.bind(inParentComponent),
		getPcaEncodedData: function () {
			return this.state.pcaEncodedData;
		}.bind(inParentComponent),

		groupStates: [],
		setGroupStates: function (groupStates: clusterStats[][][]) {
			this.setState({ groupStates: groupStates });
		}.bind(inParentComponent),

		groupAccordiansOpen: [true, false, false],
		setGroupAccordiansOpen: function (groupAccordiansOpen: boolean[]) {
			this.setState({ groupAccordiansOpen: groupAccordiansOpen });
		}.bind(inParentComponent),

		jiggleFactor: 5,
		setJiggleFactor: function (jiggleFactor: number) {
			this.setState({ jiggleFactor: jiggleFactor });
		}.bind(inParentComponent),

		plotRadialsSelected: PAIR_PLOT_RADIALS.counts,
		setPlotRadialsSelected: function (plotRadialsSelected: string) {
			this.setState({ plotRadialsSelected: plotRadialsSelected });
		}.bind(inParentComponent),

		dragVarsState: {
			draggable: undefined,
			rows: undefined,
			cols: undefined,
			values: undefined,
		},
		setDragVarsState: function (dragVarsState) {
			this.setState({ dragVarsState: dragVarsState });
		}.bind(inParentComponent),

		isAddChartOpen: false,
		setIsAddChartOpen: function (isAddChartOpen: boolean) {
			this.setState({ isAddChartOpen: isAddChartOpen });
		}.bind(inParentComponent),
		addChartInputs: {
			title: "test",
			chart_type: "Pie Charts",
			var1: "Industry",
			var2: "Prefered Communcation",
			value: "Signed In",
			agg_type: "Count",
			index: 0,
		},
		setAddChartInputs: function (addChartInputs: addChartProps) {
			this.setState({ addChartInputs: addChartInputs });
		}.bind(inParentComponent),
		resetAddChartInputs: function () {
			this.setState({
				addChartInputs: {
					title: undefined,
					chart_type: undefined,
					var1: undefined,
					var2: undefined,
					value: undefined,
					agg_type: undefined,
					index: undefined,
				},
			});
		}.bind(inParentComponent),

		chartAggData: { rowLabels: [], colLabels: [], arr: [[]], counts: [[]] },
		setChartAggData: function (chartAggData) {
			this.setState({ chartAggData: chartAggData });
		}.bind(inParentComponent),

		addedCharts: [],
		setAddedCharts: function (addedCharts: addedChartsType[]) {
			this.setState({ addedCharts: addedCharts });
		}.bind(inParentComponent),

		isAddPopupEditMode: false,
		setIsAddPopupEditMode: function (isAddPopupEditMode: boolean) {
			this.setState({ isAddPopupEditMode: isAddPopupEditMode });
		}.bind(inParentComponent),

		nPersonaPages: 1,
		setNPersonaPages: function (nPersonaPages: number) {
			this.setState({ nPersonaPages: nPersonaPages });
		}.bind(inParentComponent),

		currentPersonaPage: 1,
		setCurrentPersonaPage: function (currentPersonaPage: number) {
			this.setState({ currentPersonaPage: currentPersonaPage });
		}.bind(inParentComponent),

		personaPredicted: "",
		setPersonaPredicted: function (personaPredicted: string) {
			this.setState({ personaPredicted: personaPredicted });
		}.bind(inParentComponent),

		isPersonaPopupOpen: false,
		setIsPersonaPopupOpen: function (isPersonaPopupOpen: boolean) {
			this.setState({ isPersonaPopupOpen: isPersonaPopupOpen });
		}.bind(inParentComponent),

		personaName: "",
		setPersonaName: function (personaName: string) {
			this.setState({ personaName: personaName });
		}.bind(inParentComponent),
		isDeletPersonaOpen: false,
		setIsDeletePersonaOpen: function (isDeletPersonaOpen: string) {
			this.setState({ isDeletPersonaOpen: isDeletPersonaOpen });
		}.bind(inParentComponent),

		personaAvatarSelected: 0,
		setPersonaAvatarSelected: function (personaAvatarSelected: number) {
			this.setState({ personaAvatarSelected: personaAvatarSelected });
		}.bind(inParentComponent),
		editingPersona: -1,
		setEditingPersona: function (editingPersona: number) {
			this.setState({ editingPersona: editingPersona });
		}.bind(inParentComponent),

		cleanData: {
			data: [[]],
			headers: [""],
		},
		setCleanData: function (cleanData: batchDataType) {
			this.setState({ cleanData: cleanData });
		}.bind(inParentComponent),

		isAnalyzing: false,
		setIsAnalyzing: function (isAnalyzing: boolean) {
			this.setState({ isAnalyzing: isAnalyzing });
		}.bind(inParentComponent),

		isLoadingPopupOpen: false,
		setIsLoadingPopupOpen: function (isLoadingPopupOpen: boolean) {
			this.setState({ isLoadingPopupOpen: isLoadingPopupOpen });
		}.bind(inParentComponent),

		batchTableColSort: [],
		setBatchTableColSort: function (batchTableColSort: string[]) {
			this.setState({ batchTableColSort: batchTableColSort });
		}.bind(inParentComponent),

		batchTablePage: 0,
		setBatchTablePage: function (batchTablePage: number) {
			this.setState({ batchTablePage: batchTablePage });
		}.bind(inParentComponent),

		batchFilters: [
			{
				column: "",
				operation: "",
				value: "",
				isValid: true,
			},
		],
		setBatchFilters: function (batchFilters: batchFilterType[]) {
			this.setState({ batchFilters: batchFilters });
		}.bind(inParentComponent),

		batchFilteredData: undefined,
		setBatchFilteredData: function (batchFilteredData: any[][]) {
			this.setState({ batchFilteredData: batchFilteredData });
		}.bind(inParentComponent),

		cleanTableColSort: [],
		setCleanTableColSort: function (cleanTableColSort: string[]) {
			this.setState({ cleanTableColSort: cleanTableColSort });
		}.bind(inParentComponent),

		cleanTablePage: 0,
		setCleanTablePage: function (cleanTablePage: number) {
			this.setState({ cleanTablePage: cleanTablePage });
		}.bind(inParentComponent),

		cleanFilters: [
			{
				column: "",
				operation: "",
				value: "",
				isValid: true,
			},
		],
		setCleanFilters: function (cleanFilters: batchFilterType[]) {
			this.setState({ cleanFilters: cleanFilters });
		}.bind(inParentComponent),

		cleanFilteredData: [[]],
		setCleanFilteredData: function (cleanFilteredData: any[][]) {
			this.setState({ cleanFilteredData: cleanFilteredData });
		}.bind(inParentComponent),

		scatterCleanVarsSelected: ["Minutes on Website", "Website Visits"],
		setScatterCleanVarsSelected: function (
			scatterCleanVarsSelected: string[]
		) {
			this.setState({
				scatterCleanVarsSelected: scatterCleanVarsSelected,
			});
		}.bind(inParentComponent),

		currentDataFilter: makeCleanDataFilter({
			operation: "",
			value: "",
			replace_with: "",
			column: "Minutes on Website",
			drop_row: false,
			index: undefined,
		}),
		setCurrentDataFilter: function (
			currentDataFilter: cleanDataFilterType
		) {
			this.setState({ currentDataFilter: currentDataFilter });
		}.bind(inParentComponent),

		dropRowsFilterSelected: false,
		setDropRowsFilterSelected: function (dropRowsFilterSelected: boolean) {
			this.setState({ dropRowsFilterSelected: dropRowsFilterSelected });
		}.bind(inParentComponent),

		filterSummary: { rowsModified: 0, rowsDropped: 0 },
		setFilterSummary: function (filterSummary) {
			this.setState({ filterSummary: filterSummary });
		}.bind(inParentComponent),

		autoFilters: [],
		setAutoFilters: function (autoFilters: cleanDataFilterType[]) {
			this.setState({ autoFilters: autoFilters });
		}.bind(inParentComponent),

		getCurrentModels: function (colType: string) {
			let models: string[];
			if (colType === DATA_TYPES.number) {
				models = Object.values(REGRESSSION_MODELS);
			} else if (colType === DATA_TYPES.categorical) {
				models = Object.values(CLASSIFICATION_MODELS);
			} else {
				console.log("NoModels");
			}
			return models;
		},

		isNewDashPopUpOpen: false,
		setIsNewDashPopUpOpen: function (isNewDashPopUpOpen: boolean) {
			this.setState({ isNewDashPopUpOpen: isNewDashPopUpOpen });
		}.bind(inParentComponent),

		tempDashName: "",
		setTempDashName: function (tempDashName: string) {
			this.setState({ tempDashName: tempDashName });
		}.bind(inParentComponent),

		setNewDashName: function () {
			const state = this.state;
			// state.dashboardNames.unshift(state.tempDashName);
			state.saveState.dashboardName = state.tempDashName;
			state.setSaveState(state.saveState);
			// state.setDashboardNames(state.dashboardNames);
		}.bind(inParentComponent),

		dashToDelete: "",
		setDashToDelete: function (dashToDelete: string) {
			this.setState({ dashToDelete: dashToDelete });
		}.bind(inParentComponent),

		isDeleteDashOpen: false,
		setIsDeleteDashOpen: function (isDeleteDashOpen: boolean) {
			this.setState({ isDeleteDashOpen: isDeleteDashOpen });
		}.bind(inParentComponent),

		saveErrorMessage: "",
		setSaveErrorMessage: function (saveErrorMessage: boolean) {
			this.setState({ saveErrorMessage: saveErrorMessage });
		}.bind(inParentComponent),

		isSaveErrorOpen: false,
		setIsSaveErrorOpen: function (isSaveErrorOpen: boolean) {
			this.setState({ isSaveErrorOpen: isSaveErrorOpen });
		}.bind(inParentComponent),

		isResetDashOpen: false,
		setIsResetDashOpen: function (isResetDashOpen: boolean) {
			this.setState({
				isResetDashOpen: isResetDashOpen,
			});
		}.bind(inParentComponent),

		isRejectedDropOpen: false,
		setIsRejectedDropOpen: function (isRejectedDropOpen: boolean) {
			this.setState({
				isRejectedDropOpen: isRejectedDropOpen,
			});
		}.bind(inParentComponent),

		rejectedReason: "",
		setRejectedReason: function (rejectedReason: string) {
			this.setState({
				rejectedReason: rejectedReason,
			});
		}.bind(inParentComponent),

		isSavingDashOpen: false,
		setIsSavingDashOpen: function (isSavingDashOpen: string) {
			this.setState({
				isSavingDashOpen: isSavingDashOpen,
			});
		}.bind(inParentComponent),

		exHoverState: new Map(
			examples.concat(examples2).map((val) => [val.title, 3])
		),
		setExHoverState: function (exHoverState: Map<string, number>) {
			this.setState({ exHoverState: exHoverState });
		}.bind(inParentComponent),
		getExHoverState: function () {
			return this.state.exHoverState;
		}.bind(inParentComponent),

		isSuccessContactOpen: false,
		isFailedContactOpen: false,
		setIsSuccessContactOpen: function (isSuccessContactOpen: boolean) {
			this.setState({ isSuccessContactOpen: isSuccessContactOpen });
		}.bind(inParentComponent),
		setIsFailedContactOpen: function (isFailedContactOpen: boolean) {
			this.setState({ isFailedContactOpen: isFailedContactOpen });
		}.bind(inParentComponent),

		contactStatusMessage: "",
		setContactStatusMessage: function (contactStatusMessage: string) {
			this.setState({ contactStatusMessage: contactStatusMessage });
		}.bind(inParentComponent),

		isContactSubmitDisabled: false,
		setIsContactSubmitDisabled: function (
			isContactSubmitDisabled: boolean
		) {
			this.setState({ isContactSubmitDisabled: isContactSubmitDisabled });
		}.bind(inParentComponent),

		setContactEndpoint: function (contactEndpoint: string) {
			this.setState({ contactEndpoint: contactEndpoint });
		}.bind(inParentComponent),

		articleApplicationSelected: ARTICLES.sales_leads,
		setArticleApplicationSelected: function (
			articleApplicationSelected: string
		) {
			this.setState({
				articleApplicationSelected: articleApplicationSelected,
			});
		}.bind(inParentComponent),

		nClusters: 1,
		setNeClusters: function (nClusters: number) {
			this.setState({ nClusters: nClusters });
		}.bind(inParentComponent),

		isCloudPopupOpen: false,
		setIsCloudPopupOpen: function (isCloudPopupOpen: boolean) {
			this.setState({ isCloudPopupOpen: isCloudPopupOpen });
		}.bind(inParentComponent),

		tagClicked: "",
		setTagClicked: function (tagClicked: string) {
			this.setState({ tagClicked: tagClicked });
		}.bind(inParentComponent),

		cloudPopupPageSelected: 0,
		setCloudPopupPageSelected: function (cloudPopupPageSelected: number) {
			this.setState({ cloudPopupPageSelected: cloudPopupPageSelected });
		}.bind(inParentComponent),

		enteredPhrases: Array(MAX_TOPICS).fill(""),
		setEnteredPhrases: function (enteredPhrase: string[], ndx: number) {
			let tmp = this.state.enteredPhrases;
			tmp[ndx] = enteredPhrase;
			this.setState({ enteredPhrases: tmp });
		}.bind(inParentComponent),

		enteredTopicNames: Array(MAX_TOPICS)
			.fill("")
			.map((v, i) => getEmptyCustomTopic(i).topicName),
		setEnteredTopicNames: function (enteredTopicNames: string[]) {
			this.setState({ enteredTopicNames: enteredTopicNames });
		}.bind(inParentComponent),

		shouldUpdatePhrases: true,
		setShouldUpdatePhrases: function (shouldUpdatePhrases: boolean) {
			this.setState({ shouldUpdatePhrases: shouldUpdatePhrases });
		}.bind(inParentComponent),

		checkedTopics: Array(MAX_TOPICS).fill(true),
		setCheckedTopics: function (checkedTopics: boolean, index: number) {
			let tmp = this.state.checkedTopics;
			tmp[index] = checkedTopics;
			this.setState({ checkedTopics: tmp });
		}.bind(inParentComponent),

		setAllCheckedTopics: function (checkedTopics: boolean[]) {
			this.setState({ checkedTopics: checkedTopics });
		}.bind(inParentComponent),
		setAllEnteredPhrases: function (enteredPhrases: string[]) {
			this.setState({ enteredPhrases: enteredPhrases });
		}.bind(inParentComponent),
		isTopicsProcessing: false,
		setIsTopicsProcessing: function (isTopicsProcessing: boolean) {
			this.setState({ isTopicsProcessing: isTopicsProcessing });
		}.bind(inParentComponent),

		reCaclSentTable: true,
		setReCalcSentTable: function (reCaclSentTable: boolean) {
			this.setState({ reCaclSentTable: reCaclSentTable });
		}.bind(inParentComponent),

		sentTableData: undefined,
		setSentTableData: function (sentTableData: any[][]) {
			this.setState({ sentTableData: sentTableData });
		}.bind(inParentComponent),

		isPosCloudOpen: false,
		setIsPosCloudOpen: function (isPosCloudOpen: boolean) {
			this.setState({ isPosCloudOpen: isPosCloudOpen });
		}.bind(inParentComponent),
		isNegCloudOpen: false,
		setIsNegCloudOpen: function (isNegCloudOpen: boolean) {
			this.setState({ isNegCloudOpen: isNegCloudOpen });
		}.bind(inParentComponent),
		errorCaught: false,
		setErrorCaught: function (errorCaught: boolean) {
			this.setState({ errorCaught: errorCaught });
		}.bind(inParentComponent),

		errorPopupOpen: false,
		setErrorPopupOpen: function (errorPopupOpen: boolean) {
			this.setState({ errorPopupOpen: errorPopupOpen });
		}.bind(inParentComponent),

		//Save State
		saveState: getSaveState(),
		setSaveState: function (
			saveState_: typeof saveStateType,
			isModified: boolean
		) {
			if (isModified !== undefined) {
				this.setState({ saveStateModified: isModified });
			}
			this.setState({ saveState: saveState_ });
		}.bind(inParentComponent),
		setFileName: function (
			fileName: string,
			saveState_: typeof saveStateType
		) {
			saveState_.dataUpload.fileName = fileName;
			this.setState({ saveState: saveState_ });
		}.bind(inParentComponent),

		saveStateModified: false,
		setSaveStateModified: function (saveStateModified: boolean) {
			this.setState({ saveStateModified: saveStateModified });
		}.bind(inParentComponent),
	};
}
